import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
export const init = async function() {
    // configure Swiper to use modules
    Swiper.use([
        Navigation,
        Pagination,
        Lazy
    ]);
    new Swiper('.js-fabric-carousel', {
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'progressbar'
        },
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        spaceBetween: 12,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },
        // Enable lazy loading
        lazy: {
            loadPrevNext: true
        },
        breakpoints: {
            1024: {
                slidesPerView: 'auto',
                spaceBetween: 28
            }
        }
    });
};
